module.exports = __webpack_public_path__ + "static/media/action.162d2807.svg";